"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldFileUploadCoreInputs = void 0;
class EmeraldFileUploadCoreInputs {
    constructor() {
        /**
         * A flag indicating whether the file upload component is disabled.
         */
        this.disabled = false;
        /**
         * A flag indicating whether the file upload is required.
         */
        this.required = false;
        /**
         * The total maximum file size allowed for all files combined, in bytes.
         * This is useful when you want to limit the total size of multiple files uploaded at once.
         */
        this.totalMaxFileSize = 0; // Total max size for all files, if applicable
        /**
         * The label for the input field where users can select files or drop them to upload.
         * This can be customized to provide a more descriptive label for the input area.
         */
        this.inputLabel = 'Select file(s) or drop here to upload';
        /**
         * The label for the upload button.
         * This can be customized to provide a more descriptive label for the button.
         */
        this.uploadButtonLabel = 'Browse Files';
        /**
         * The variant of the file upload component.
         * This can be used to change the layout or style of the component.
         * Default is 'default', but can also be 'labelOnTop' for a different layout.
         */
        this.variant = 'default';
        /**
         * An array of default uploaded files.
         * This can be used to pre-populate the file upload component with existing files.
         */
        this.uploadedFiles = [];
        /**
         * A flag indicating whether the current file upload state is valid.
         * This can be used to determine if the uploaded files meet the specified criteria (e.g., size, type).
         */
        this.isValid = true; // Indicates if the current file upload state is valid
        /**
         * The tab index for the file upload component.
         */
        this.tabIndex = 0; // Default tab index for accessibility
    }
}
exports.EmeraldFileUploadCoreInputs = EmeraldFileUploadCoreInputs;
//# sourceMappingURL=file-upload.inputs.js.map